import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Sidebar from '../../../../components/Sidebar/Sidebar';
import UserProfileDropdown from '../../../../components/UserProfile/UserProfile';
import SeedsLogo from '../../../../assets/images/SeedsLogo.png';
import HomeSvg from '../../../../components/SVG/HomeSvg';
import { Container } from 'react-bootstrap';
import '../../../UserManagement/components/Layout/Layout.css';

const Layout = () => {
    const navigate = useNavigate();

    return (
        <Container fluid className="user-management" style={{ padding: "0px" }}>
            <div className="applicationsDashboard">
                <Sidebar />

                <div className="dashboardMainContent">
                    <div className="contentHeader">
                        <div className="userLogo">
                            <img src={SeedsLogo} alt="logo" className="SeedsLogo" />
                        </div>
                        <div className="headerRightPanel">
                            <UserProfileDropdown />
                        </div>
                    </div>

                    <div className="userPageContent">
                        <div className="user-management-header d-flex justify-content-between align-items-center">
                            <div className="headerLeft d-flex align-items-center gap-2">
                                <div
                                    onClick={() => navigate('/stage-transition-rules')}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <HomeSvg fillColor={'#002355'} />
                                </div>
                                <h5 className="title mb-0">Stage Transition Rules</h5>
                            </div>
                        </div>

                        <div className="dashboard-content" style={{ flex: 1, padding: '24px' }}>
                            <Outlet />
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    );
};

export default Layout;
